import { connect } from 'react-redux';
import PanelFormatSettings from '../../components/handoff/PanelFormatSettings';
import { setUnit, setCurrentLang, enablePercentageBasedGuidelines, disablePercentageBasedGuidelines, setColorMode, } from '../../actionCreators';
import { arePercentageBasedGuidelinesEnabled, getColorMode, getUnit, } from '../../selectors/handoff';
import { getCurrentLanguage } from '../../selectors/code';
function mapStateToProps(state) {
    return {
        unit: getUnit(state),
        currentLang: getCurrentLanguage(state),
        arePercentageGuidesEnabled: arePercentageBasedGuidelinesEnabled(state),
        colorMode: getColorMode(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        changeMeasurementUnit: function (unit) {
            dispatch(setUnit(unit));
        },
        changeColorMode: function (colorMode) {
            dispatch(setColorMode(colorMode));
        },
        setCurrentLang: function (lang) {
            dispatch(setCurrentLang(lang));
        },
        enablePercentageGuides: function () {
            dispatch(enablePercentageBasedGuidelines());
        },
        disablePercentageGuides: function () {
            dispatch(disablePercentageBasedGuidelines());
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(PanelFormatSettings);
